<template>
  <div class="app-container" v-bar>
    <div>
      <div class="integratedData-main">
        <div class="integratedData-row-first">
          <div class="integratedData-col">
            <OssData v-if="ossStorage" :ossStorage="ossStorage" />
          </div>
          <div class="integratedData-col">
            <GPT v-if="gptData" :gptData="gptData" />
          </div>
        </div>
        <template v-if="permissions.length">
          <div
            class="integratedData-row-second"
            v-for="(data, index) in permissions"
            :key="index"
          >
            <div
              class="integratedData-col"
              v-for="item of data"
              :key="item.tag"
            >
              <PermissionsData :permissionData="item" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import OssData from './components/ossData.vue'
import GPT from './components/chatgpt.vue'
import PermissionsData from './components/permissionData.vue'
export default {
  components: {
    OssData,
    GPT,
    PermissionsData
  },
  data() {
    return {
      ossStorage: null,
      gptData: null,
      permissions: []
    }
  },
  methods: {
    async getData() {
      this.getOssOverView()
      this.getChatGptYear()
      this.getAiYear()
    },

    async getOssOverView() {
      let res = await this.$http.getOssOverView()
      this.ossStorage = res.data
    },

    async getChatGptYear() {
      let res = await this.$http.getChatGptYear()
      this.gptData = res.data ? res.data : {}
    },

    async getAiYear() {
      let res = await this.$http.getAiYear()
      let resultArray = res.data.filter((item) => item.tag !== 'docOcr')
      let size = 2
      // 使用循环和 slice() 方法将原始数组切割成多个数组
      for (var i = 0; i < resultArray.length; i += size) {
        var sliceArray = resultArray.slice(i, i + size)
        this.permissions.push(sliceArray)
      }
      console.log(this.permissions, 'pzzz')
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="scss">
.integratedData-main {
  padding: 20px;
  .integratedData-row-first,
  .integratedData-row-second {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .integratedData-col {
      width: calc(50% - 10px);
      display: flex;
      /* padding: 0 10px; */
    }
  }
  .integratedData-row-first {
    height: 413px;
    overflow: hidden;
  }
  .integratedData-row-second {
    /* height: 413px;
    flex-wrap: wrap;
    overflow: hidden; */
  }
}
</style>
